import { render, staticRenderFns } from "./SectionsTable.vue?vue&type=template&id=34be0eb0&"
import script from "./SectionsTable.vue?vue&type=script&lang=ts&"
export * from "./SectionsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports